// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"8d4212c5","98":"09fc2530","113":"345cb584","161":"7a5dbf78","205":"79e2b0d3","641":"6ccb367e","780":"439245f0","843":"bc6773c8","938":"ba93987c"}[chunkId] + ".chunk.css";
};